module.exports = __webpack_public_path__ + "img/search-big.cb61ea87.svg";